
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import { formatUpyunUrl } from "@/utils";
// import {openJesongChat} from "easy"
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { generateMetaInfo, getServiceJsonLd } from "@/utils/seo";
@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb
  }
})
export default class Emba extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "大思维书院 | 终身学习·轻辅导·微咨询·核心资源 - 光华赋能",
      description:
        "光华共创会大思维书院，面向企业负责人提供终身学习、轻辅导、微咨询与核心资源对接服务。加入共创会圈层，学东西、交朋友、整资源、增业务。",
      keywords:
        "大思维书院,共创会,终身学习,企业辅导,微咨询,资源对接,企业圈层,光华赋能",
      path: "/academy",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "共创会" },
        { name: "大思维书院" }
      ],
      jsonLd: getServiceJsonLd({
        name: "大思维书院",
        description:
          "面向企业负责人的终身学习、轻辅导、微咨询与核心资源对接服务平台。",
        category: "企业学习圈层"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/dbc0b3a98b45b19d6e3f9b9a6394465a.png";
  pic2 = "/img/99102a48fda68ec77d66efc585287266.png";
  pic3 = "/img/5ee4fff72d4a59e53a5c5b17577a69bb.png";
  pic4 = "/img/ba3b398d82884330504058ed5e0aef0f.png";
  companyArr: any = [];
  List = [
    { title: "共创会", url: "" },
    { title: "大思维书院", url: "" }
  ];
  created() {
    this.initData();
  }
  initData() {
    let companyArr0 = [];
    let companyArr1 = [];
    console.log(123456);
    for (let index = 1; index < 6; index++) {
      companyArr0.push("/gh_website/academy" + index + ".png");
    }
    for (let index = 6; index < 12; index++) {
      companyArr1.push("/gh_website/academy" + index + ".png");
    }
    this.companyArr.push(companyArr0);
    this.companyArr.push(companyArr1);
    console.log("companyArr", this.companyArr);
  }
  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "共创会，大思维书院，实战EMBA，EMBA，常青藤"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业老板，专业的老板,实战EMBA,总裁班,学东西，交朋友，整资源，提升业务，企业负责人,联合创始人,企业接班人,大思维书院说明：标杆企业家,终身说明，前沿趋势，提升思维，思维层次，终身学习，大思维，科学经营底座，高质量发展常青藤说明：新生代企业家，传承接力，破局求变，转型升级，户外拓展，企业家私董会，共创会EMBA校友日，校友日，共创会年度高峰论坛，高峰论坛，论坛，精品研学，同学小聚"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
